import React from 'react';
import { baseXInPixels, breakpoints } from '../../styles/theme';
import {
  propToResponsivePropObject,
  ResponsiveProp
} from '../../utils/layoutUtils';

export type TimState = 'talk' | 'inactive' | 'idle' | 'reveal';

const Tim: React.FunctionComponent<{
  animateIn?: boolean;
  state?: TimState;
  onAnimationDone?: () => void;
  onReveal?: () => void;
  size?: ResponsiveProp<number>;
}> = ({ size = 2.25 }) => {
  const sizeValues = propToResponsivePropObject(size).mapDefined(
    (value: number) => Math.ceil(baseXInPixels(value)) + 'px'
  );

  return (
    <div className="tim">
      <img src="/play.svg" alt="x" className="tim-logo-replacement" />
      {/*language=CSS*/}
      <style jsx data-testid="tim-styles">{`
        .tim {
          display: flex;
          align-items: center;
          justify-content: center;
          width: ${sizeValues.small};
          height: ${sizeValues.small};
        }
        .tim-logo-replacement {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        @media ${breakpoints.medium} {
          .tim {
            width: ${sizeValues.medium};
            height: ${sizeValues.medium};
          }
        }

        @media ${breakpoints.large} {
          .tim {
            width: ${sizeValues.large};
            height: ${sizeValues.large};
          }
        }
      `}</style>
    </div>
  );
};

export default Tim;
